export enum AutoReturnAndResendTabStatus {
    Unavailable = 0,
    ReShipping = 1,
    AutoReturnAvailable = 2,
    Processing = 3,
}

export type AutoReturnAndResendTab = 'resend' | 'autoReturn' | 'processed' | 'notFound';

export type AutoReturnAndResendMainTab = 'operation' | 'reports';

export type AutoReturnReportStatus = 'completed' | 'failed';

export type AutoReturnReportItemStatus = 'success' | 'failed';

export interface ShipmentRow {
    orderNumber?: string;
    shippingListNo: string;
    shippingListId?: number;
}

export type ProcessedRowStatus = 'queued' | 'processing';

export interface ProcessedRow extends ShipmentRow {
    processedBy: string;
    processedAt: string;
    status: ProcessedRowStatus;
}

export interface AutoReturnAndResendItemDto {
    shippingListNo: string;
    shippingListId: number;
    orderNumber: string;
    tabStatus: AutoReturnAndResendTabStatus;
}

export interface CheckAutoReturnAndResendStatusRequest {
    shippingListNumbers: string[];
}

export interface CheckAutoReturnAndResendStatusResponse {
    items: AutoReturnAndResendItemDto[];
    totalCount: number;
    unavailableCount: number;
    reShippingCount: number;
    autoReturnAvailableCount: number;
    processingCount: number;
}

export interface ProcessAutoReturnBulkRequest {
    shippingListNumbers: string[];
}

export interface ProcessAutoReturnBulkResponse {
    rpaRequestId: number;
    queuedCount: number;
    skippedCount: number;
    queuedShippingListNumbers: string[];
    skippedShippingListNumbers: string[];
    message: string;
}

export interface AutoReturnReportDetailItem extends ShipmentRow {
    status?: AutoReturnReportItemStatus;
    statusDescription?: string;
    statusKey?: string;
}

export interface AutoReturnReport {
    rpaRequestId?: number | string;
    createDate?: string;
    userName?: string;
    statusDescription?: string;
    statusKey?: string;
    reportId?: string;
    createdAt?: string;
    processedBy?: string;
    status?: AutoReturnReportStatus;
    totalCount?: number;
    successCount?: number;
    failedCount?: number;
    items?: AutoReturnReportDetailItem[];
}

export interface AutoReturnReportDetailRequest {
    rpaRequestId: number | string;
}

export type AutoReturnReportsResponse =
    | AutoReturnReport[]
    | {
          items?: AutoReturnReport[];
          data?: AutoReturnReport[];
      };

export type AutoReturnReportDetailsResponse =
    | AutoReturnReport
    | AutoReturnReportDetailItem[]
    | {
          items?: AutoReturnReportDetailItem[];
          data?: AutoReturnReport | AutoReturnReportDetailItem[];
      };

export interface MockSearchResult {
    resendRows: ShipmentRow[];
    autoReturnRows: ShipmentRow[];
    notFoundRows: ShipmentRow[];
}

export type ExcelFilePrefix =
    'TekrarSevk' | 'OtomatikIade' | 'IslemGorenler' | 'Bulunamayan' | 'OtomatikIadeRaporDetay';
